import { ManifestLoadedData } from "../types";

/**
 * Calculates the end date of an MPD by finding the latest period's end time.
 *
 * @param periods - Array of MPD periods with segment information
 * @param availabilityStartTime - The availability start time of the MPD in milliseconds
 * @returns The end date of the MPD as a Date object, or null if no valid periods found
 */
export const calculateComputedAvailabilityEndTime = (
  periods: ManifestLoadedData["Period"],
  availabilityStartTime: Date
): Date | null => {
  if (!Array.isArray(periods) || periods.length === 0) {
    return null;
  }

  const lastPeriod = periods[periods.length - 1];
  const availabilityStartTimeUnix = availabilityStartTime.getTime();
  const lastPeriodStart = lastPeriod.start * 1000;
  const lastPeriodDuration = lastPeriod.duration * 1000;
  const availabilityEndTime =
    availabilityStartTimeUnix + lastPeriodStart + lastPeriodDuration;

  console.log(lastPeriod);

  return new Date(availabilityEndTime);
};
